import { useState } from "react";
import { useAuth } from "../../context/AuthContext";
import CloseIcon from "../svgs/CloseIcon";

const LogoutLink = () => {
  const { logout, isLoading } = useAuth();
  const [openPopup, setOpenPopup] = useState(false);

  const handleLogout = async () => {
    try {
      await logout();
      window.location.href = "/";
    } catch (err) {
      console.error("Logout failed:", err);
    }
  };

  return (
    <>
      <a
        href="#"
        onClick={(e) => {
          e.preventDefault();
          handleLogout();
        }}
        className="navbar_dropdown_link"
      >
        {isLoading ? "Logging out..." : "Logout"}
      </a>
      <div className={`popup ${openPopup && "popup__show"}`}>
        <div className="popup__bg"></div>
        <div className="popup__component">
          <button
            onClick={() => {
              setOpenPopup(!openPopup);
            }}
            className="popup__close"
          >
            <CloseIcon />
          </button>

          <div className="popup__text__wrapper">
            <p className="popup__heading">Are you sure you want to log out?</p>
            <p className="popup__text">Any unsaved changes may be lost.</p>
          </div>
          <div className="popup__button__wrapper">
            <button
              onClick={(e) => {
                e.preventDefault();
                handleLogout();
              }}
              className="button is-red"
            >
              Delete your profile
            </button>
            <button
              className="button is-red is-outline"
              onClick={() => {
                setOpenPopup(!openPopup);
              }}
            >
              Cancel
            </button>
          </div>
        </div>
      </div>
    </>
  );
};

export default LogoutLink;
